<template>
  <template v-if="!Util.isEmpty(Vendors)">
    <DataTable :id="ID" class="table-hover table-lg" :options="Options">
      <thead>
        <tr class="nk-tb-item nk-tb-head">
          <th class="nk-tb-col nk-tb-col-check">
            <div
              class="custom-control custom-control-sm custom-checkbox notext"
            >
              <input type="checkbox" class="custom-control-input" id="uid" />
              <label class="custom-control-label" for="uid"></label>
            </div>
          </th>
          <th class="nk-tb-col" style="min-width: 200px">Vendor name</th>
          <th class="nk-tb-col tb-col-mb">Payables</th>
          <th class="nk-tb-col tb-col-lg">Telephone</th>
          <th class="nk-tb-col tb-col-md">Email</th>
          <th class="nk-tb-col nk-tb-col-tools text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="nk-tb-item" v-for="vendor in Vendors" :key="vendor.uuid">
          <td class="nk-tb-col nk-tb-col-check">
            <div
              class="custom-control custom-control-sm custom-checkbox notext"
            >
              <input type="checkbox" class="custom-control-input" id="uid1" />
              <label class="custom-control-label" for="uid1"></label>
            </div>
          </td>
          <td class="nk-tb-col">
            <router-link
              :to="{ name: 'vendor-detail', params: { uuid: vendor.uuid } }"
              class="cursor"
            >
              <div class="size15 nowrap ellipsis">
                {{ vendor.vendor_name + " " }}
              </div>
              <div v-if="vendor.fullname" class="size12 w3-text-grey ellipsis">
                <span class="d-none"> (</span>
                {{ vendor.fullname }}
                <span class="d-none">)</span>
              </div>
            </router-link>
          </td>
          <td class="nk-tb-col tb-col-md" v-html="Util.Currency('0.00')"></td>
          <td class="nk-tb-col tb-col-lg ellipsis">
            <a
              v-if="vendor.mobile"
              :href="'tel:' + vendor.mobile"
              target="_blank"
              class="d-block"
              >{{ vendor.mobile }}
            </a>
            <a
              v-if="vendor.telephone"
              :href="'tel:' + vendor.email"
              target="_blank"
              class="d-block"
              >{{ vendor.telephone }}
            </a>
          </td>
          <td class="nk-tb-col tb-col-md ellipsis">
            <a
              v-if="vendor.email"
              :href="'mailto:' + vendor.email"
              target="_blank"
              >{{ vendor.email }}
            </a>
          </td>
          <td class="nk-tb-col nk-tb-col-tools">
            <ul class="nk-tb-actions gx-1">
              <li>
                <div class="drodown">
                  <a
                    href="#"
                    class="dropdown-toggle btn btn-icon btn-trigger"
                    data-toggle="dropdown"
                    ><em class="icon ni ni-more-h"></em>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul class="link-list-opt no-bdr">
                      <li>
                        <a
                          title="Create New Bill"
                          :data-uuid="vendor.uuid"
                          href="#"
                        >
                          <em class="icon ni ni-file"></em>
                          <span>New Bill</span></a
                        >
                      </li>
                      <li>
                        <a
                          title="Create New Purchase Order"
                          :data-uuid="vendor.uuid"
                          href="#"
                        >
                          <em class="icon fas fa-file-alt"></em>
                          <span>New Purchase Order</span></a
                        >
                      </li>

                      <li class="divider"></li>
                      <li>
                        <a
                          title="Email Vendor"
                          :data-uuid="vendor.uuid"
                          @click.prevent="DeleteDetail(vendor.uuid)"
                          href="#"
                        >
                          <em class="icon ni ni-mail-fill"></em>
                          <span>Email Vendor</span></a
                        >
                      </li>
                      <li>
                        <router-link
                          title="Vendor Detail"
                          :to="{
                            name: 'vendor-detail',
                            params: { uuid: vendor.uuid },
                          }"
                          class="cursor"
                        >
                          <em class="icon ni ni-eye"></em>
                          <span>Vendor Detail</span></router-link
                        >
                      </li>
                      <li>
                        <a
                          title="Edit"
                          :data-uuid="vendor.uuid"
                          @click.prevent="QuickEdit(vendor.uuid)"
                          href="#"
                        >
                          <em class="icon fas fa-edit"></em>
                          <span>Edit Vendor</span></a
                        >
                      </li>
                      <li>
                        <a
                          title="Edit"
                          :data-uuid="vendor.uuid"
                          @click.prevent="DeleteDetail(vendor.uuid)"
                          href="#"
                        >
                          <em class="icon fas fa-trash"></em>
                          <span>Delete Vendor</span></a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </DataTable>
  </template>
  <div v-else class="p-5 w3-center">
    <img src="/images/item-not-found.png" class="mb-4" />
    <h4>No Item was found</h4>
    <a
      href="#"
      title="Add new vendor"
      class="btn btn-white btn-dim btn-outline-light"
      @click.prevent="addVendor = true"
    >
      <em class="icon ni ni-edit"></em>
      <span class="d-none d-md-inline">Add a new vendor</span>
    </a>
  </div>
  <AddVendor
    :toggle-by="addVendor"
    @oncancel="addVendor = false"
    @onsave="addVendor = false"
    title="Add new item"
  ></AddVendor>
  <Aside
    :toggle-by="DoEdit"
    @oncancel="OnCancel"
    cancel-text="Cancel"
    width="1024px"
  >
    <VendorUpdate
      tabbed
      v-if="DoEdit"
      :vendor="Vendor"
      @onsave="OnSave"
      @oncancel="OnCancel"
    />
  </Aside>
</template>
<script>
import {
  // computed,
  ref,
  toRef,
} from "vue";
import { useStore } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { Util } from "@/helpers/utilities";
import DataTable from "@/components/ui/DataTable.vue";
import VendorUpdate from "@/components/ui/vendor/VendorUpdate.vue";
import AddVendor from "@/components/ui/vendor/AddVendor.vue";
import Aside from "@/components/ui/Aside.vue";
export default {
  components: {
    DataTable,
    AddVendor,
    VendorUpdate,
    Aside,
  },
  props: {
    id: {
      type: String,
    },
    vendors: {
      type: Array,
    },
  },

  setup(props) {
    const store = useStore();
    const ID = props.id ? props.id : uuidv4();
    const Vendors = toRef(props, "vendors");
    const addVendor = ref(false);
    const Options = {
      pageLength: 25,
      responsive: false,
      order: [[1, "asc"]],
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: [0],
        },
      ],
    };

    const DeleteDetail = (uuid) => {
      console.log("DeleteDetail", uuid);
    };
    const Vendor = ref({});
    const DoEdit = ref(false);
    const QuickEdit = async (uuid) => {
      const _vendor = await store.dispatch("vendors/getVendor", uuid);
      Vendor.value = {
        ..._vendor,
      };
      DoEdit.value = true;
    };
    const OnCancel = () => {
      Vendor.value = {};
      DoEdit.value = false;
    };
    const OnSave = () => {
      OnCancel();
    };
    return {
      store,
      ID,
      Vendor,
      Vendors,
      addVendor,
      QuickEdit,
      Util,
      Options,
      OnSave,
      DeleteDetail,
      DoEdit,
      OnCancel,
    };
  },
};
</script>